<template>
  <div id="sensorDataHistory" class="animated fadeIn h-100">
    <b-row class="h-100">
      <div id="Loader" v-if="LoadYn">
        <div class="spinner-bar">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
      <b-col style="flex: 0 0 20%; max-width: 20%" class="tree pr20">
        <b-card
          class="h-100 black-border1"
          body-class="h-100 p10"
          header-tag="header"
        >
          <h6 slot="header">차트 조회 옵션</h6>
          <b-form @submit.prevent="getData" class="chartOptions">
            <b-row>
              <b-col>
                <label>프로젝트</label>
                <vue-select
                  class="select-container w200"
                  v-model="search.projectid"
                  :options="search.projectOptions"
                  @input="getStidList"
                  :reduce="(a) => a.value"
                  label="text"
                  :clearable="false"
                  required
                >
                </vue-select>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <label>구조물</label>
                <vue-select
                  class="select-container w200"
                  v-model="search.stid"
                  :options="search.stidOptions"
                  @input="getDeviceId"
                  :reduce="(a) => a.value"
                  label="text"
                  :clearable="false"
                  required
                >
                </vue-select>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <label>디바이스</label>
                <b-form-select
                  v-model="search.device"
                  :options="search.deviceOptions"
                  @change="getSensorAlias"
                  required
                ></b-form-select>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <label>센서</label>
                <b-form-select
                  v-model="search.sensorAlias"
                  :options="search.sensorAliasOptions"
                  required
                ></b-form-select>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <label>데이터</label>
                <b-form-select
                  v-model="search.dataType"
                  :options="search.dataTypeOptions"
                  value="file"
                  required
                ></b-form-select>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <label>시작 일자</label>
                <b-form-input
                  type="date"
                  v-model="search.stDate"
                  :max="search.edDate"
                  required
                ></b-form-input>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <label>종료일자 </label>
                <b-form-input
                  type="date"
                  v-model="search.edDate"
                  :min="search.stDate"
                  :max="search.maxDate"
                  required
                ></b-form-input>
              </b-col>
            </b-row>
            <b-row v-show="search.dataType === 'rawe'">
              <b-col>
                <label>FFT Avg Cnt</label>
                <b-form-input
                  v-model="search.fftAvgCnt"
                  :required="search.dataType === 'rawe'"
                ></b-form-input>
              </b-col>
            </b-row>
            <b-row v-show="search.dataType === 'rawe'">
              <b-col>
                <label>Clustering Cnt</label>
                <b-form-input
                  v-model="search.clusteringCnt"
                  :required="search.dataType === 'rawe'"
                ></b-form-input>
              </b-col>
            </b-row>
            <div class="btnGrp">
              <div class="jcse">
                <!-- <b-button class="full-excelBtn" @click="chartDataDownload"><i class="fas fa-download"></i>다운로드</b-button> -->
                <b-button
                  class="full-searchBtn"
                  type="submit"
                  :disabled="search.btnDisabled"
                  >조회</b-button
                >
              </div>
            </div>
          </b-form>
          <b-form
            v-if="search.fileAnalOptYn"
            @submit.prevent="getFileData"
            class="chartOptions"
          >
            <b-row>
              <b-col>
                <label>분석 일자</label>
                <b-form-select
                  v-model="search.fileDate"
                  :options="search.fileDateOptions"
                  @change="getFileList"
                  required
                ></b-form-select>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <label>분석 파일</label>
                <b-form-select
                  v-model="search.fileName"
                  :options="search.fileNameOptions"
                  required
                ></b-form-select>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <label>Num of Data</label>
                <b-form-select
                  v-model="search.numofdata"
                  :options="search.numofdataOptions"
                  required
                ></b-form-select>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <label>Overlap(%)</label>
                <b-form-input
                  type="number"
                  v-model="search.overlap"
                  required
                ></b-form-input>
              </b-col>
            </b-row>
            <div class="btnGrp">
              <div class="jcse">
                <b-button
                  class="full-searchBtn"
                  type="submit"
                  :disabled="search.btnDisabled"
                  >분석</b-button
                >
              </div>
            </div>
          </b-form>

          <div class="chartOptions">
            <b-row>
              <b-col>
                <label class="w200">Sampling Rate</label>
                <b-form-input
                  v-model="samplingRate"
                  disabled
                  class="w100"
                ></b-form-input>
              </b-col>
            </b-row>
          </div>
        </b-card>
      </b-col>
      <b-col style="flex: 0 0 80%; max-width: 80%" class="cont">
        <b-row class="h-100 chartarea" v-if="graphmode === '1'">
          <b-col class="col-12">
            <div class="h62 p15 searchBox mb15 border0">
              <div>
                <label class="pb2">총 데이터 수</label>
                <b-form-input v-model="totalDataCount" disabled></b-form-input>
              </div>
              <div>
                <b-button
                  class="excelBtn"
                  @click="excelDownload"
                  :disabled="csvFilePath == null"
                  ><i class="fas fa-download"></i>다운로드</b-button
                >
                <!-- <b-button class="full-excelBtn" @click="chartDataDownload"><i class="fas fa-download"></i>다운로드</b-button> -->
                <!-- <b-button class="resetBtn w35 py5 px0" style="border-radius: 5px;" @click="openSetting"><i class="fas fa-cog mr0"></i></b-button> -->
              </div>
            </div>
            <b-card class="hc-sub77 border0" body-class="h-100 p20">
              <b-row class="h-50 pb10">
                <b-col class="col-6 pr10">
                  <b-card
                    class="h-100 default-border1"
                    body-class="h-100 p-0"
                    header-tag="header"
                  >
                    <h6 slot="header">
                      {{ raweChart.title.chart1 }}
                    </h6>
                    <div id="sdataHistChart1" class="graph"></div>
                  </b-card>
                </b-col>
                <b-col class="col-6 pl10">
                  <b-card
                    class="h-100 default-border1"
                    body-class="h-100 p-0"
                    header-tag="header"
                  >
                    <h6 slot="header">
                      {{ raweChart.title.chart2 }}
                    </h6>
                    <div id="sdataHistChart2" class="graph"></div>
                  </b-card>
                </b-col>
              </b-row>
              <b-row class="h-50 pt10">
                <b-col class="col-6 pr10">
                  <b-card
                    class="h-100 default-border1"
                    body-class="h-100 p-0"
                    header-tag="header"
                  >
                    <h6 slot="header">
                      {{ raweChart.title.chart3 }}
                    </h6>
                    <div id="sdataHistChart3" class="graph"></div>
                  </b-card>
                </b-col>
                <b-col class="col-6 pl10">
                  <b-card
                    class="h-100 default-border1"
                    body-class="h-100 p-0"
                    header-tag="header"
                  >
                    <h6 slot="header">
                      {{ raweChart.title.chart4 }}
                    </h6>
                    <div id="sdataHistChart4" class="graph"></div>
                  </b-card>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
        <b-row class="h-100 chartarea" v-else>
          <b-col class="col-12">
            <div class="h62 p15 searchBox mb15 border0">
              <div>
                <label class="pb2">진행상황</label>
                <div class="animated fadeIn prog" v-if="progress.rawfiledown">
                  <i class="fas fa-file-download mr10"></i>RAW FILE
                  다운로드<font
                    v-if="progress.rawfiledownfin"
                    class="ml10"
                    color="#22a75d"
                    ><i class="fas fa-check"></i
                  ></font>
                </div>
                <div class="animated fadeIn prog" v-if="progress.bin2csv">
                  <i class="fas fa-arrow-right"></i>
                </div>
                <div class="animated fadeIn prog" v-if="progress.bin2csv">
                  <i class="fas fa-file-csv mr10"></i>CSV 변환<font
                    v-if="progress.bin2csvfin"
                    class="ml10"
                    color="#22a75d"
                    ><i class="fas fa-check"></i
                  ></font>
                </div>
                <div class="animated fadeIn prog" v-if="progress.anal">
                  <i class="fas fa-arrow-right"></i>
                </div>
                <div class="animated fadeIn prog" v-if="progress.anal">
                  <i class="fas fa-wave-square mr10"></i>분석
                  <b-spinner
                    v-if="progress.anal && !progress.analfin"
                    class="h20 w20 ml15"
                    label="Loading..."
                  ></b-spinner>
                  <font v-if="progress.analfin" class="ml10" color="#22a75d"
                    ><i class="fas fa-check"></i
                  ></font>
                </div>
              </div>
              <div>
                <b-form-checkbox
                  v-model="search.accumulate"
                  value="Y"
                  unchecked-value="N"
                  :disabled="search.checkboxDisabled"
                  >데이터 누적 여부</b-form-checkbox
                >
                <b-button
                  class="excelBtn"
                  @click="excelDownload"
                  :disabled="csvFilePath == null"
                  ><i class="fas fa-download"></i>다운로드</b-button
                >
                <!-- <b-button class="full-excelBtn" @click="chartDataDownload"><i class="fas fa-download"></i>다운로드</b-button> -->
              </div>
            </div>
            <b-card class="hc-sub77 border0" body-class="h-100 p20">
              <b-row class="h-50 pb10">
                <b-col class="col-4 pr10">
                  <b-card
                    class="h-100 default-border1"
                    body-class="h-100 p-0"
                    header-tag="header"
                  >
                    <h6 slot="header">
                      {{ fileChart.title.chart1 }}
                    </h6>
                    <div id="filechart1" class="graph"></div>
                  </b-card>
                </b-col>
                <b-col class="col-4 px5">
                  <b-card
                    class="h-100 default-border1"
                    body-class="h-100 p-0"
                    header-tag="header"
                  >
                    <h6 slot="header">
                      {{ fileChart.title.chart2 }}
                    </h6>
                    <div id="filechart2" class="graph"></div>
                  </b-card>
                </b-col>
                <b-col class="col-4 pl10">
                  <b-card
                    class="h-100 default-border1"
                    body-class="h-100 p-0"
                    header-tag="header"
                  >
                    <h6 slot="header">
                      {{ fileChart.title.chart3 }}
                    </h6>
                    <div id="filechart3" class="graph"></div>
                  </b-card>
                </b-col>
              </b-row>
              <b-row class="h-50 pt10">
                <b-col class="col-4 pr10">
                  <b-card
                    class="h-100 default-border1"
                    body-class="h-100 p-0"
                    header-tag="header"
                  >
                    <h6 slot="header">
                      {{ fileChart.title.chart4 }}
                    </h6>
                    <div id="filechart4" class="graph"></div>
                  </b-card>
                </b-col>
                <b-col class="col-4 px5">
                  <b-card
                    class="h-100 default-border1"
                    body-class="h-100 p-0"
                    header-tag="header"
                  >
                    <h6 slot="header" style="font-size: 12px">
                      {{ fileChart.title.chart5 }}
                    </h6>
                    <div id="filechart5" class="graph"></div>
                  </b-card>
                </b-col>
                <b-col class="col-4 pl10">
                  <b-card
                    class="h-100 default-border1"
                    body-class="h-100 p-0"
                    header-tag="header"
                  >
                    <h6 slot="header">
                      {{ fileChart.title.chart6 }}
                    </h6>
                    <div id="filechart6" class="graph"></div>
                  </b-card>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
        <div class="rawe-progress" v-if="raweChart.progress.loadyn">
          <b-progress
            :max="raweChart.progress.totval"
            variant="success"
            animated
          >
            <b-progress-bar
              :value="raweChart.progress.curval"
              :label="`${(
                (raweChart.progress.curval / raweChart.progress.totval) *
                100
              ).toFixed(1)}%`"
            ></b-progress-bar>
          </b-progress>
        </div>
      </b-col>
    </b-row>
    <!-- <b-modal id="sensorDataChartSettingModal" title="Scale 설정 정보" title-tag="h5" header-class="jcc" centered hide-footer no-close-on-backdrop no-close-on-esc hide-header-close>
      <sensor-data-chart-setting-modal settingType="RF" @researchChartConfig="getSensorChartConfig" @researchChartData="getData"></sensor-data-chart-setting-modal>
    </b-modal> -->
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import moment from "moment";
import utils from "../common/utils";
import chartUtil from "../common/chartUtil";
// import SensorDataChartSettingModal from "./SensorDataSettingModal";
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";
var Plotly = require("plotly.js/dist/plotly.min.js");

export default {
  components: {
    // SensorDataChartSettingModal,
    VueSelect,
  },
  computed: {
    ...mapGetters([
      "getUserId",
      "getUserAuth",
      "getCenterBus",
      "getAlertOptions",
      "getSelectedDataProjectid",
      "getSelectedDataStid",
      "getSelectedDataStartDate",
      "getSelectedDataEndDate",
      "getWebSocket",
    ]),
  },
  watch: {
    "search.edDate": function (param) {
      this.search.minDate = moment(param)
        .subtract(this.search.dataType === "file" ? 1 : 7, "day")
        .format("YYYY-MM-DD");
    },
    "search.dataType": function (param) {
      this.search.fileAnalOptYn = false;
      this.search.minDate = moment(this.search.edDate)
        .subtract(param === "file" ? 1 : 7, "day")
        .format("YYYY-MM-DD");
      if (param === "rawe") {
        this.search.fftAvgCnt = 10;
        this.search.clusteringCnt = 2;
      } else if (param === "file") {
        this.search.numofdata = 8192;
        this.search.overlaying = 10;
      }
    },
    "search.device": function (param) {
      if (param !== null) {
        if (String(param).split("/")[0] === "2") {
          this.search.sensorShow = false;
        } else {
          this.search.sensorShow = true;
        }
      } else {
        this.search.sensorShow = true;
        this.search.sensorAlias = null;
        this.search.sensorAliasOptions = [{ value: null, text: "선택" }];
      }
    },
    "search.sensorAlias": function (param) {
      this.getSamplingRate(param);
    },
    "search.stid": function (param) {
      this.getDeviceId(param);
    },
    graphmode: function (param) {
      if (param === "1") {
        // rawe Type 실행
        Plotly.purge("filechart1");
        Plotly.purge("filechart2");
        Plotly.purge("filechart3");
        Plotly.purge("filechart4");
        Plotly.purge("filechart5");
        Plotly.purge("filechart6");
      } else {
        // file Type 실행
        Plotly.purge("sdataHistChart1");
        Plotly.purge("sdataHistChart2");
        Plotly.purge("sdataHistChart3");
        Plotly.purge("sdataHistChart4");
      }
    },
  },
  data() {
    return {
      totalDataCount: null,
      csvFilePath: null,
      chartConfig: {},
      graphmode: "1",
      search: {
        projectid: null,
        projectOptions: [{ value: null, text: "선택" }],
        stid: null,
        stidOptions: [{ value: null, text: "선택" }],
        device: null,
        deviceOptions: [{ value: null, text: "선택" }],
        sensorAlias: null,
        sensorAliasOptions: [{ value: null, text: "선택" }],
        dataType: null,
        dataTypeOptions: [
          { value: null, text: "선택" },
          { value: "rawe", text: "RAWE" },
          { value: "file", text: "FILE" },
        ],
        stDate: null,
        edDate: null,
        minDate: null,
        maxDate: null,
        fftAvgCnt: 10,
        clusteringCnt: 2,
        fileAnalOptYn: false,
        fileDate: null,
        fileDateOptions: [{ value: null, text: "선택" }],
        fileName: null,
        fileNameOptions: [{ value: null, text: "선택" }],
        numofdata: 1024,
        numofdataOptions: [],
        overlap: 10,
        overlapOptions: [],
        sensorShow: true,
        accumulate: "N",
        btnDisabled: false,
        checkboxDisabled: false,
      },
      raweChart: {
        title: {
          chart1: "Trigger-event time history Data PLOT",
          chart2: "Averaged frequency analysis Data PLOT",
          chart3: "Main frequency component Cluster Data PLOT",
          chart4: "Change of cluster center PLOT",
        },
        chart1: [
          {
            x: null,
            y: null,
            name: null,
            type: "scatter",
            mode: "lines",
            line: { width: 1 },
          },
        ],
        chart2: [],
        chart3: [
          {
            x: [],
            y: [],
            mode: "markers",
            type: "scatter",
            marker: {
              size: 10,
              color: [],
            },
          },
        ],
        chart4: [
          {
            x: [],
            y: [],
            mode: "markers",
            type: "scatter",
            marker: {
              symbol: [],
              size: 15,
              color: [],
            },
          },
        ],
        progress: {
          totval: 30,
          curval: 29,
          loadyn: false,
        },
      },
      fileChart: {
        chart1: {
          clearyn: false,
          data: [
            {
              x: [0, 0, null, 0, 0],
              y: [0, 0, null, 0, 0],
              type: "scatter",
              mode: "lines",
              line: {
                color: "white",
                width: 1,
              },
            },
          ],
          ymax: 0,
          ymin: 0,
        },
        chart2: {
          clearyn: true,
          data: [],
        },
        chart3: {
          clearyn: true,
          data: [],
        },
        chart4: {
          clearyn: true,
          data: [],
        },
        chart5: {
          clearyn: false,
          data: [],
        },
        chart6: {
          clearyn: false,
          data: [],
        },
        title: {
          chart1: "Trigger-event time history Data PLOT",
          chart2: "Averaged frequency analysis Data PLOT",
          chart3: "Main frequency component Cluster Data PLOT",
          chart4: "Change of cluster center PLOT",
          chart5: "Main frequency component Cluster Data PLOT",
          chart6: "Change of cluster center PLOT",
        },
      },
      fileList: {},
      subscription: null,
      checkData: {
        timer: null,
        lastUpdate: null,
      },
      chartData: [],
      LoadYn: false,
      progress: {
        rawfiledown: false,
        rawfiledownfin: false,
        bin2csv: false,
        bin2csvfin: false,
        anal: false,
        analfin: false,
      },
      isFirstCall: true,
      websocketDatType: null,
      samplingRate: null,
    };
  },
  created() {
    this.getDefaultCodes();
    this.getSensorChartConfig();
    this.getProjectList();
  },
  beforeMount() {},
  mounted() {
    this.search.minDate = moment().subtract(7, "day").format("YYYY-MM-DD");
    this.search.stDate = moment().add(0, "day").format("YYYY-MM-DD");
    this.search.edDate = moment().add(0, "day").format("YYYY-MM-DD");
    this.search.maxDate = moment().add(0, "day").format("YYYY-MM-DD");
    this.getCenterBus.$on("getDeviceId", (param) => {
      var reqBody = {
        code: param.code,
      };
      this.getDeviceId(reqBody);
    });

    if (this.getSelectedDataStartDate) {
      this.search.stDate = this.getSelectedDataStartDate;
    }
    if (this.getSelectedDataEndDate) {
      this.search.edDate = this.getSelectedDataEndDate;
    }

    this.getCenterBus.$on("webSocketServerMessage", (param) => {
      if (param) {
        switch (param.target) {
          case "rabbitMQData":
            let data = JSON.parse(param.data);
            if (this.websocketDatType == "scube_rawe") {
              this.subRaweData(data);
            } else {
              this.subFileData(data);
            }
            break;
          case "rabbitMQError":
            this.setAlertTitle();
            this.$bvModal
              .msgBoxOk(param.data, this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
            break;
        }
      }
    });
  },
  destroyed() {
    this.getCenterBus.$off("getDeviceId");
  },
  methods: {
    ...mapMutations([
      "setAlertTitle",
      "setSelectedDataProjectid",
      "setSelectedDataStid",
      "setSelectedDataStartDate",
      "setSelectedDataEndDate",
    ]),
    getDefaultCodes() {
      for (let i = 0; i <= 5; i++) {
        this.search.numofdataOptions.push({
          value: 1024 * Math.pow(2, i),
          text: 1024 * Math.pow(2, i),
        });
      }
      for (let i = 1; i <= 8; i++) {
        this.search.overlapOptions.push({
          value: 10 * i,
          text: 10 * i,
        });
      }
      /* var reqBody = {
        codegrp: ''
      }
      this.$http.post('/comn/code', reqBody).then((res) => {
        if (res.data.resultyn === 'Y') {
        } else {
          this.setAlertTitle()
          this.$bvModal.msgBoxOk('관리자에게 문의하세요.', this.getAlertOptions).then(value => {
          }).catch(err => {
            console.error(err)
          })
        }
      }).catch((err) => {
        console.error(err)
      }) */
    },
    getSensorChartConfig() {
      var reqBody = {
        settingtype: "RF",
      };
      this.$http
        .post("/sensor/getSensorChartConfig", reqBody)
        .then((res) => {
          if (res.data.resultyn === "Y") {
            let config = res.data.data;
            this.chartConfig = config;
          } else {
            this.setAlertTitle();
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getProjectList() {
      var reqBody = {};
      this.$http
        .post("/stat/getProjectListAll", reqBody) // HICC230608
        .then((res) => {
          if (res.data.resultyn === "Y") {
            let data = res.data.data;
            let options = [{ value: null, text: "선택" }];
            const projst = {
              PRE: "(준비중)",
              SVC: "",
              IDL: "(휴면)",
              EXP: "(종료)",
            };
            for (let i = 0; i < data.length; i++) {
              options.push({
                value: data[i].projectid,
                text: data[i].projectname + projst[data[i].projstate],
              });
            }
            this.search.projectOptions = options;
            if (this.getSelectedDataProjectid) {
              this.search.projectid = this.getSelectedDataProjectid;
              this.getStidList();
            } else this.search.projectid = null;
          } else {
            this.setAlertTitle("프로젝트 조회 실패");
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getStidList() {
      if (!this.search.projectid) {
        this.search.stidOptions = [{ value: null, text: "선택" }];
        this.search.stid = null;
        return;
      }
      var reqBody = {
        projectid: this.search.projectid,
      };
      this.$http
        .post("/sensor/getStidList", reqBody)
        .then((res) => {
          if (res.data.resultyn === "Y") {
            let data = res.data.data;
            let options = [{ value: null, text: "선택" }];
            for (let i = 0; i < data.length; i++) {
              options.push({
                value: data[i].stid,
                text: data[i].stname,
              });
            }
            this.search.stidOptions = options;
            if (this.isFirstCall) {
              if (this.getSelectedDataStid) {
                this.search.stid = this.getSelectedDataStid;
                this.getDeviceId(this.search.stid);
              } else this.search.stid = null;
            } else this.search.stid = null;
            this.isFirstCall = false;
          } else {
            this.setAlertTitle("구조물 조회 실패");
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getDeviceId(param) {
      var reqBody = {
        stid: param,
        category: "dynamic",
      };
      this.$http
        .post("/device/getDeviceId", reqBody)
        .then((res) => {
          if (res.data.resultyn === "Y") {
            var devlist = res.data.data;
            var options = [{ value: null, text: "선택" }];
            for (let i = 0; i < devlist.length; i++) {
              options.push({
                value: devlist[i].deviceid,
                text: devlist[i].devicename,
              });
            }
            this.search.device = null;
            this.search.deviceOptions = options;

            if (options.length > 1) {
              this.search.device = options[1].value;
            } else {
              this.search.device = options[0].value;
            }
            this.getSensorAlias(this.search.device);
          } else {
            this.setAlertTitle();
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getSensorAlias(deviceId) {
      this.search.dataType = null;
      if (deviceId === null) {
        this.search.sensorAlias = null;
        this.search.sensorAliasOptions = [{ value: null, text: "선택" }];
      } else {
        var reqBody = {
          deviceid: deviceId,
        };
        this.$http
          .post("/sensor/getSensorAlias", reqBody)
          .then((res) => {
            if (res.data.resultyn === "Y") {
              var sensorlist = res.data.data;
              var options = [{ value: null, text: "선택" }];
              for (let i = 0; i < sensorlist.length; i++) {
                options.push({
                  value: sensorlist[i].idx,
                  text: sensorlist[i].sensoralias,
                });
              }
              if (options.length === 2) {
                this.search.sensorAliasOptions = options.slice(1);
                this.search.sensorAlias = options[1].value;
              } else {
                this.search.sensorAliasOptions = options;
                this.search.sensorAlias = null;
              }
              this.search.dataType = "file";
            } else {
              this.setAlertTitle();
              this.$bvModal
                .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
                .then((value) => {})
                .catch((err) => {
                  console.error(err);
                });
            }
          })
          .catch((err) => {
            console.error(err);
          });
      }
    },
    getFileList(param) {
      this.search.fileNameOptions = this.fileList[param];
    },
    // 센서 데이터 조회
    getData() {
      // 설정 바꾸지전 차트 한번이라도 조회 한 적이 없는 경우 재조회 하지 않음
      if (this.search.sensorAlias === null || this.search.dataType === null)
        return;

      this.csvFilePath = null;
      var reqBody = {
        devid: this.search.device,
        datatype: this.search.dataType,
        sensoridx: this.search.sensorAlias,
        stdate: moment(this.search.stDate).format("YYYYMMDD"),
        eddate: moment(this.search.edDate).format("YYYYMMDD"),
      };

      this.setSelectedDataProjectid(this.search.projectid);
      this.setSelectedDataStid(this.search.stid);
      this.setSelectedDataStartDate(this.search.stDate);
      this.setSelectedDataEndDate(this.search.edDate);

      if (this.search.dataType === "rawe") {
        reqBody.fftavgcnt = this.search.fftAvgCnt;
        reqBody.clusteringcnt = this.search.clusteringCnt;
        this.LoadYn = true;
      }
      this.$http
        .post("/sensor/getDataAnalysisAvgFft", reqBody, { timeout: 600000 })
        .then((res) => {
          if (res.data.resultyn === "Y") {
            if (this.search.dataType === "rawe") {
              this.graphmode = "1";
              this.LoadYn = false;
              var chartData = res.data.data;
              // console.log(chartData)
              // 총 데이터 수 셋팅
              this.totalDataCount = chartData.data_cnt;
              this.csvFilePath = chartData.csv_file_path;
              if (
                Object.keys(chartData).length !== 0 &&
                chartData.mq_topic_id !== undefined
              ) {
                this.initRaweChart();

                this.websocketDatType = "scube_rawe";
                this.getWebSocket.send(
                  JSON.stringify({
                    target: "onRabbitMQData",
                    exchange: "scube_rawe",
                    topic: chartData.mq_topic_id,
                  })
                );
              } else {
                this.setAlertTitle();
                this.$bvModal
                  .msgBoxOk(
                    "해당 데이터가 존재하지 않습니다.",
                    this.getAlertOptions
                  )
                  .then((value) => {})
                  .catch((err) => {
                    console.error(err);
                  });
              }
            } else {
              this.search.fileAnalOptYn = true;
              var date = res.data.data.date;
              var options = [{ value: null, text: "선택" }];
              // 파일리스트 변수 초기화
              this.fileList = {};
              for (let i = 0; i < date.length; i++) {
                options.push({
                  value: date[i],
                  text: moment(date[i]).format("YYYY-MM-DD"),
                });
                // 일자별 파일 리스트 셋팅
                this.fileList[date[i]] = [{ value: null, text: "선택" }];
                for (let j = 0; j < res.data.data.file[date[i]].length; j++) {
                  this.fileList[date[i]].push({
                    value: res.data.data.file[date[i]][j],
                    text: res.data.data.file[date[i]][j],
                  });
                }
              }
              // 분석 가능 일자 초기화
              if (this.search.fileDate !== null) this.search.fileDate = null;
              // 분석 일자 셋팅
              this.search.fileDateOptions = options;
            }
          } else {
            this.setAlertTitle("데이터 조회 실패");
            this.$bvModal
              .msgBoxOk(res.data.errormsg, this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getFileData() {
      var reqBody = {
        devid: this.search.device,
        datatype: this.search.dataType,
        type: "fileanal",
        sensoridx: this.search.sensorAlias,
        date: moment(this.search.fileDate).format("YYYYMMDD"),
        file: this.search.fileName,
        numofdata: this.search.numofdata,
        overlap: this.search.overlap,
      };
      this.LoadYn = true;
      this.$http
        .post("/sensor/getDataAnalysisAvgFft", reqBody, { timeout: 600000 })
        .then((res) => {
          if (res.data.resultyn === "Y") {
            this.graphmode = "2";
            this.initFileChart();
            var chartData = res.data.data;
            for (let i = 0; i < chartData.chart_info.length; i++) {
              this.fileChart.title["chart" + chartData.chart_info[i].chart_no] =
                chartData.chart_info[i].title;
            }
            // this.subFileData(chartData);

            this.websocketDatType = "raw_file";
            this.getWebSocket.send(
              JSON.stringify({
                target: "onRabbitMQData",
                exchange: "raw_file",
                topic: chartData.mq_topic_id,
              })
            );
          } else {
            this.setAlertTitle();
            this.$bvModal
              .msgBoxOk(res.data.errormsg, this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    // x축이 시간인 라인 차트 그리기
    drawTimeLineChart(id, data, param, range) {
      var Data = [
        {
          x: data.x,
          y: data.y,
          name: data.name,
          type: "scatter",
          mode: "lines",
          line: { width: 1 },
        },
      ];
      var tmpLayout = document.getElementById(id);
      var layout = {
        xaxis: {
          zeroline: false,
          color: "#e2e2e2",
          tickmode: "auto",
          nticks: data.x.length > 4 ? 4 : data.x.length,
          tickformat: "%Y-%m-%d %H:%M:%S",
        },
        yaxis: {
          zeroline: false,
          color: "#e2e2e2",
        },
        paper_bgcolor: "#2e3339",
        plot_bgcolor: "#2e3339",
        width: Math.floor(tmpLayout.clientWidth - 1), // 276,
        height: Math.floor(tmpLayout.clientHeight - 1), // 282,
        margin: {
          l:
            utils.chkNull(param.annotation) !== null &&
            utils.chkNull(param.annotation.yaxis) !== null
              ? 80
              : 50,
          r: 80,
          t: 20,
          b: 30,
          pad: 0,
        },
        // legend: {orientation: 'h', x: 0.45, y: -0.15},
        annotations: [],
      };
      // Annotation Xaxis Setting
      if (
        utils.chkNull(param.annotation) !== null &&
        utils.chkNull(param.annotation.xaxis) !== null
      ) {
        layout.annotations.push(
          this.setChartAnnotation("x", param.annotation.xaxis)
        );
      }
      // Annotation Yaxis Setting
      if (
        utils.chkNull(param.annotation) !== null &&
        utils.chkNull(param.annotation.yaxis) !== null
      ) {
        layout.annotations.push(
          this.setChartAnnotation("y", param.annotation.yaxis)
        );
      }
      if (utils.chkNull(range) !== null) {
        if (
          utils.chkNull(range.x) !== null &&
          (range.x.min !== 0 || range.x.max !== 0)
        ) {
          layout.xaxis.range = [range.x.min, range.x.max];
        }
        if (
          utils.chkNull(range.y) !== null &&
          (range.y.min !== 0 || range.y.max !== 0)
        ) {
          layout.yaxis.range = [range.y.min, range.y.max];
        }
      }
      Plotly.newPlot(id, Data, layout);
    },
    // 일반적인 라인 차트 그리기
    drawLineChart(id, dataArr, param, range) {
      var data = dataArr;
      var layout = chartUtil.setLayout(id, {
        datacnt: dataArr[0].x.length,
        showxaxiscnt: 4,
        annotation: param.annotation,
      });
      if (id === "filechart5") {
        layout.xaxis.type = "log";
        layout.yaxis.type = "log";
      }
      layout.margin = {
        l:
          utils.chkNull(param.annotation) !== null &&
          utils.chkNull(param.annotation.yaxis) !== null
            ? 80
            : 50,
        r: utils.chkNull(param.showlegend, true) ? 80 : 50,
        t: 20,
        b: 30,
        pad: 0,
      };
      layout.showlegend = utils.chkNull(param.showlegend, true);
      if (utils.chkNull(range) !== null) {
        if (
          utils.chkNull(range.x) !== null &&
          (range.x.min !== 0 || range.x.max !== 0)
        ) {
          layout.xaxis.range = [range.x.min, range.x.max];
        }
        if (
          utils.chkNull(range.y) !== null &&
          (range.y.min !== 0 || range.y.max !== 0)
        ) {
          layout.yaxis.range = [range.y.min, range.y.max];
        }
      }
      Plotly.newPlot(id, data, layout, {
        modeBarButtonsToAdd: ["sendDataToCloud"],
        showSendToCloud: true,
        plotlyServerURL: "https://chart-studio.plotly.com",
      });
    },
    // 여러 트레이스를 가진 라인 차트 그리기
    drawSeveralLineChart(id, dataArr, param, range) {
      var data = dataArr;
      var layout = chartUtil.setLayout(id, {
        datacnt: dataArr[0].x.length,
        showxaxiscnt: 5,
        annotation: param.annotation,
      });
      layout.margin = {
        l:
          utils.chkNull(param.annotation) !== null &&
          utils.chkNull(param.annotation.yaxis) !== null
            ? 80
            : 50,
        r: utils.chkNull(param.showlegend, true) ? 80 : 50,
        t: 20,
        b: 30,
        pad: 0,
      };
      layout.showlegend = utils.chkNull(param.showlegend, true);
      if (utils.chkNull(range) !== null) {
        if (
          utils.chkNull(range.x) !== null &&
          (range.x.min !== 0 || range.x.max !== 0)
        ) {
          layout.xaxis.range = [range.x.min, range.x.max];
        }
        if (
          utils.chkNull(range.y) !== null &&
          (range.y.min !== 0 || range.y.max !== 0)
        ) {
          layout.yaxis.range = [range.y.min, range.y.max];
        }
      }
      Plotly.newPlot(id, data, layout);
    },
    // Y축이 좌우인 라인 차트 그리기
    drawDualAxisLineChart(id, data, param, range) {
      var Data = [
        {
          x: data.x,
          y: data.y1,
          name: data.name1,
          type: "scatter",
          mode: "lines",
          line: { width: 1 },
        },
        {
          x: data.x,
          y: data.y2,
          name: data.name2,
          type: "scatter",
          mode: "lines",
          yaxis: "y2",
          line: { width: 1 },
        },
      ];
      var tmpLayout = document.getElementById(id);
      var layout = {
        xaxis: {
          zeroline: false,
          color: "#e2e2e2",
          tickmode: "auto",
          nticks: data.x.length > 4 ? 4 : data.x.length,
          tickformat: "%Y-%m-%d %H:%M:%S",
        },
        yaxis: {
          zeroline: false,
          color: "#e2e2e2",
        },
        yaxis2: {
          zeroline: false,
          color: "#e2e2e2",
          overlaying: "y",
          side: "right",
        },
        paper_bgcolor: "#2e3339",
        plot_bgcolor: "#2e3339",
        width: Math.floor(tmpLayout.clientWidth - 1), // 276,
        height: Math.floor(tmpLayout.clientHeight - 1), // 282,
        margin: {
          l:
            utils.chkNull(param.annotation) !== null &&
            utils.chkNull(param.annotation.yaxis) !== null
              ? 80
              : 50,
          r:
            utils.chkNull(param.annotation) !== null &&
            utils.chkNull(param.annotation.yaxis2) !== null
              ? 80
              : 50,
          t: 20,
          b: 30,
          pad: 0,
        },
        legend: {
          orientation: "h",
          x: 0.45,
          y: -0.15,
          font: {
            color: "#e2e2e2",
          },
        },
        annotations: [],
      };
      // Annotation Xaxis Setting
      if (
        utils.chkNull(param.annotation) !== null &&
        utils.chkNull(param.annotation.xaxis) !== null
      ) {
        layout.annotations.push(
          this.setChartAnnotation("x", param.annotation.xaxis)
        );
      }
      // Annotation Yaxis Setting
      if (
        utils.chkNull(param.annotation) !== null &&
        utils.chkNull(param.annotation.yaxis) !== null
      ) {
        layout.annotations.push(
          this.setChartAnnotation("y", param.annotation.yaxis)
        );
      }
      // Annotation Yaxis2 Setting
      if (
        utils.chkNull(param.annotation) !== null &&
        utils.chkNull(param.annotation.yaxis2) !== null
      ) {
        layout.annotations.push(
          this.setChartAnnotation("y2", param.annotation.yaxis2)
        );
      }
      if (utils.chkNull(range) !== null) {
        if (
          utils.chkNull(range.x) !== null &&
          (range.x.min !== 0 || range.x.max !== 0)
        ) {
          layout.xaxis.range = [range.x.min, range.x.max];
        }
        if (
          utils.chkNull(range.y) !== null &&
          (range.y.min !== 0 || range.y.max !== 0)
        ) {
          layout.yaxis.range = [range.y.min, range.y.max];
        }
        if (
          utils.chkNull(range.y2) !== null &&
          (range.y2.min !== 0 || range.y2.max !== 0)
        ) {
          layout.yaxis2.range = [range.y2.min, range.y2.max];
        }
      }
      Plotly.newPlot(id, Data, layout);
    },
    // [RAWE 전용] 점 차트 그리기
    drawMarkerChart(id, dataArr, param, range) {
      let data = dataArr;
      var layout = chartUtil.setLayout(id, {
        datacnt: dataArr[0].x.length,
        showxaxiscnt: 5,
        annotation: param.annotation,
      });
      // layout.xaxis.tickformat = '.%2f'
      layout.margin = {
        l:
          utils.chkNull(param.annotation) !== null &&
          utils.chkNull(param.annotation.yaxis) !== null
            ? 80
            : 50,
        r: 80,
        t: 20,
        b: 30,
        pad: 0,
      };
      if (utils.chkNull(range) !== null) {
        if (
          utils.chkNull(range.x) !== null &&
          (range.x.min !== 0 || range.x.max !== 0)
        ) {
          layout.xaxis.range = [range.x.min, range.x.max];
        }
        if (
          utils.chkNull(range.y) !== null &&
          (range.y.min !== 0 || range.y.max !== 0)
        ) {
          layout.yaxis.range = [range.y.min, range.y.max];
        }
      }
      Plotly.newPlot(id, data, layout);
    },
    subRaweData(data) {
      console.log("subscribe!!");
      // 버튼 비활성화
      this.search.btnDisabled = true;
      // progress Loading Setting
      this.raweChart.progress.loadyn = true;
      // RAWE Data Time Check Monitoring
      this.startCheckDataMonitoring();
      // 현재 시간으로 셋팅
      this.dataLastUpdateTime = moment();

      if (data) {
        this.dataLastUpdateTime = moment();
        this.raweChart.chart2.push({
          x: data.chart2.x,
          y: data.chart2.y,
          name: "Amp" + (data.cur_no + 1),
          type: "scatter",
          mode: "lines",
          line: { width: 1 },
        });
        if (data.cur_no === 0) {
          this.raweChart.progress.totval = data.total;
          this.raweChart.title.chart1 = "Trigger-event time history Data PLOT";
          this.raweChart.title.chart2 = "Averaged frequency analysis Data PLOT";
          this.raweChart.title.chart3 =
            "Main frequency component Cluster Data PLOT";
          this.raweChart.title.chart4 = "Change of cluster center PLOT";
        }
        this.raweChart.progress.curval = data.cur_no + 1;
        // Draw Chart1 - Sensor Value
        this.raweChart.chart1[0].x = data.chart1.x;
        this.raweChart.chart1[0].y = data.chart1.y;
        this.raweChart.chart1[0].name = "Sensor Value";
        this.drawLineChart(
          "sdataHistChart1",
          this.raweChart.chart1,
          {
            annotation: {
              yaxis: {
                text: "Sensor Value(ma.u)",
                x: -0.115,
                y: 0.5,
              },
            },
            showlegend: false,
          },
          {
            y: {
              min: this.chartConfig.rawestchart1,
              max: this.chartConfig.raweedchart1,
            },
          }
        );
        // Draw Chart2 - Amplitude
        this.drawSeveralLineChart(
          "sdataHistChart2",
          this.raweChart.chart2,
          {
            annotation: {
              yaxis: {
                text: "Amplitude(a.u)",
                x: -0.14,
                y: 0.5,
              },
            },
            showlegend: false,
          },
          {
            y: {
              min: this.chartConfig.rawestchart2,
              max: this.chartConfig.raweedchart2,
            },
          }
        );
        // Draw Chart3 - Amplitude
        if (utils.chkNull(data.chart3, "") !== "") {
          // Initialize Chart3 Data
          this.raweChart.chart3[0].x = [];
          this.raweChart.chart3[0].y = [];
          this.raweChart.chart3[0].marker.color = [];
          for (let i = 0; i < data.chart3.length; i++) {
            this.raweChart.chart3[0].x.push(data.chart3[i].x);
            this.raweChart.chart3[0].y.push(data.chart3[i].y);
            this.raweChart.chart3[0].marker.color.push(
              "rgb(" + String(data.chart3[i].color) + ")"
            );
          }
          this.drawMarkerChart(
            "sdataHistChart3",
            this.raweChart.chart3,
            {
              annotation: {
                yaxis: {
                  text: "Amplitude(ma.u)",
                  x: -0.13,
                  y: 0.5,
                },
              },
            },
            {
              y: {
                min: this.chartConfig.rawestchart3,
                max: this.chartConfig.raweedchart3,
              },
            }
          );
        }
        if (utils.chkNull(data.chart4) !== null) {
          for (let i = 0; i < data.chart4.length; i++) {
            this.raweChart.chart4[0].x.push(data.chart4[i].x);
            this.raweChart.chart4[0].y.push(data.chart4[i].y);
            this.raweChart.chart4[0].marker.color.push(
              "rgba(" + String(data.chart4[i].color) + ")"
            );
            this.raweChart.chart4[0].marker.symbol.push("triangle-down");
          }
          this.drawMarkerChart(
            "sdataHistChart4",
            this.raweChart.chart4,
            {
              annotation: {
                yaxis: {
                  text: "Amplitude(ma.u)",
                  x: -0.135,
                  y: 0.5,
                },
              },
            },
            {
              y: {
                min: this.chartConfig.rawestchart4,
                max: this.chartConfig.raweedchart4,
              },
            }
          );
        }
        if (data.total === data.cur_no + 1) {
          // console.log(this.raweChart.chart4)
          // 버튼 활성화
          this.search.btnDisabled = false;
          this.stopCheckDataMonitoring();
        }
      }
    },
    subFileData(data) {
      console.log("File Data Subscribe!!");
      this.search.btnDisabled = true;
      this.search.checkboxDisabled = true;
      // let cnt = 0
      let firstYn = this.search.accumulate === "N";

      if (data) {
        if (data.state === "RAWFILE_ANAL_FIN" || data.state === "FAILED") {
          this.progress.analfin = true;
          // 버튼 활성화
          this.search.btnDisabled = false;
          // 체크박스 활성화
          this.search.checkboxDisabled = false;
          // console.log(this.fileChart['chart6'])
          this.unsubRaweData();
          // console.log(this.fileChart)
          if (data.state === "FAILED") {
            this.setAlertTitle();
            this.$bvModal.msgBoxOk(data.msg, this.getAlertOptions);
          }
        } else if (data.state === "RAWFILE_ANAL_CHART") {
          let chartData = data.data;
          // console.log(chartData)
          // First Chart1 Standard Line Settings
          if (
            Object.keys(chartData).length === 1 &&
            Object.keys(chartData).includes("chart1")
          ) {
            let datas = chartData["chart1"].data;
            let ymin = datas[0].y[0];
            let ymax = datas[0].y[0];
            if (this.fileChart["chart1"].data.length < 2) {
              this.fileChart["chart1"].data.push({
                x: datas[0].x,
                y: datas[0].y,
                type: "scatter",
                mode: "lines",
                line: { width: 1 },
              });
            } else {
              this.fileChart["chart1"].data[1].x = datas[0].x;
              this.fileChart["chart1"].data[1].y = datas[0].y;
            }
            for (let i = 1; i < datas[0].y.length; i++) {
              if (datas[0].y[i] < ymin) ymin = datas[0].y[i];
              if (datas[0].y[i] > ymax) ymax = datas[0].y[i];
            }
            this.fileChart["chart1"].ymin = ymin;
            this.fileChart["chart1"].ymax = ymax;
            this.fileChart["chart1"].data[0].x = [0, 0, null, 0, 0];
            this.fileChart["chart1"].data[0].y = [
              this.fileChart["chart1"].ymin,
              this.fileChart["chart1"].ymax,
              null,
              this.fileChart["chart1"].ymin,
              this.fileChart["chart1"].ymax,
            ];
            this.drawLineChart("filechart1", this.fileChart["chart1"].data, {
              showlegend: false,
            });
          } else if (
            Object.keys(chartData).length === 1 &&
            Object.keys(chartData).includes("chart5")
          ) {
            if (this.search.accumulate === "N") {
              let datas = chartData["chart5"].data;
              for (let i = 0; i < datas.length; i++) {
                this.fileChart["chart5"].data.push({
                  x: datas[i].x,
                  y: datas[i].y,
                  name: datas[i].name,
                  type: "scatter",
                  mode: "lines",
                  line: { color: "rgb(31, 119, 180)" } /* ,
                    marker: {
                      color: Array.from({length: datas[i].x.length}, () => 'rgb(' + String(datas[i].color) + ')'),
                      symbol: Array.from({length: datas[i].x.length}, () => datas[i].symbol)
                    } */,
                });
              }
              this.drawLineChart("filechart5", this.fileChart["chart5"].data, {
                showlegend: false,
              });
            }
          } else {
            for (let key of Object.keys(chartData)) {
              if (key.includes("chart")) {
                let datas = chartData[key].data;
                for (let i = 0; i < datas.length; i++) {
                  if (this.fileChart[key].clearyn) {
                    // chart2, chart3, chart4
                    if (datas[i].type === "line") {
                      // 받을 때 마다 새롭게 갱신하는 데이터 셋팅
                      this.fileChart[key].data = [
                        {
                          x: utils.chkNull(
                            datas[i].x,
                            Array.from(
                              { length: datas[i].y.length },
                              (v, i) => i + 1
                            )
                          ),
                          y: datas[i].y,
                          type: "scatter",
                          mode: "lines",
                          line: { width: 1 },
                        },
                      ];
                    }
                  } else {
                    // chart5, chart6
                    if (firstYn) {
                      if (datas[i].type === "line") {
                        // 받을 때마다 데이터 누적
                        this.fileChart[key].data.push({
                          x: datas[i].x,
                          y: datas[i].y,
                          type: "scatter",
                          mode: "lines",
                          line: { width: 1, color: "rgb(31, 119, 180)" },
                        });
                      } else if (datas[i].type === "scatter") {
                        this.fileChart[key].data.push({
                          x: datas[i].x,
                          y: datas[i].y,
                          type: "scatter",
                          mode: "markers",
                          marker: {
                            color: Array.from(
                              { length: datas[i].x.length },
                              () => "rgb(" + String(datas[i].color) + ")"
                            ),
                            symbol: Array.from(
                              { length: datas[i].x.length },
                              () => datas[i].symbol
                            ),
                          },
                        });
                      }
                    } else {
                      if (datas[i].type === "line") {
                        // 받을 때마다 데이터 누적
                        if (key === "chart6") {
                          this.fileChart[key].data.push({
                            x: datas[i].x,
                            y: datas[i].y,
                            type: "scatter",
                            mode: "lines",
                            line: { width: 1, color: "rgb(31, 119, 180)" },
                          });
                        }
                      } else if (datas[i].type === "scatter") {
                        if (key === "chart5") {
                          this.fileChart[key].data[
                            this.fileChart[key].data.length - 1
                          ].x = this.fileChart[key].data[
                            this.fileChart[key].data.length - 1
                          ].x.concat(datas[i].x);
                          this.fileChart[key].data[
                            this.fileChart[key].data.length - 1
                          ].y = this.fileChart[key].data[
                            this.fileChart[key].data.length - 1
                          ].y.concat(datas[i].y);
                          this.fileChart[key].data[
                            this.fileChart[key].data.length - 1
                          ].marker.color = this.fileChart[key].data[
                            this.fileChart[key].data.length - 1
                          ].marker.color.concat(
                            Array.from(
                              { length: datas[i].x.length },
                              () => "rgb(" + String(datas[i].color) + ")"
                            )
                          );
                          this.fileChart[key].data[
                            this.fileChart[key].data.length - 1
                          ].marker.symbol = this.fileChart[key].data[
                            this.fileChart[key].data.length - 1
                          ].marker.symbol.concat(
                            Array.from(
                              { length: datas[i].x.length },
                              () => datas[i].symbol
                            )
                          );
                        } else {
                          this.fileChart[key].data.push({
                            x: datas[i].x,
                            y: datas[i].y,
                            type: "scatter",
                            mode: "markers",
                            marker: {
                              color: Array.from(
                                { length: datas[i].x.length },
                                () => "rgb(" + String(datas[i].color) + ")"
                              ),
                              symbol: Array.from(
                                { length: datas[i].x.length },
                                () => datas[i].symbol
                              ),
                            },
                          });
                        }
                      }
                    }
                  }
                  if (key !== "chart6") {
                    this.drawLineChart("file" + key, this.fileChart[key].data, {
                      showlegend: false,
                    });
                  } else {
                    this.drawSeveralLineChart(
                      "file" + key,
                      this.fileChart[key].data,
                      {
                        showlegend: false,
                      }
                    );
                  }
                  if (key === "chart2") {
                    this.fileChart["chart1"].data[0].x = [
                      this.fileChart["chart1"].data[1].x[
                        chartData[key].data_range[0]
                      ],
                      this.fileChart["chart1"].data[1].x[
                        chartData[key].data_range[0]
                      ],
                      null,
                      this.fileChart["chart1"].data[1].x[
                        chartData[key].data_range[1]
                      ],
                      this.fileChart["chart1"].data[1].x[
                        chartData[key].data_range[1]
                      ],
                    ];
                    this.fileChart["chart1"].data[0].y = [
                      this.fileChart["chart1"].ymin,
                      this.fileChart["chart1"].ymax,
                      null,
                      this.fileChart["chart1"].ymin,
                      this.fileChart["chart1"].ymax,
                    ];
                    this.drawLineChart(
                      "filechart1",
                      this.fileChart["chart1"].data,
                      {
                        showlegend: false,
                      }
                    );
                  }
                }
              }
            }
            if (Object.keys(chartData).length >= 5) {
              firstYn = false;
            }
          }
        } else {
          switch (data.state) {
            case "RAWFILE_DOWNLOAD":
              this.progress.rawfiledown = true;
              break;
            case "RAWFILE_DOWNLOAD_FIN":
              if (!this.progress.rawfiledown) this.progress.rawfiledown = true;
              this.progress.rawfiledownfin = true;
              break;
            case "RAWFILE_BIN2CSV":
              this.progress.bin2csv = true;
              break;
            case "RAWFILE_BIN2CSV_FIN":
              this.progress.bin2csvfin = true;
              this.csvFilePath = data.csv_file_path;
              break;
            case "RAWFILE_ANAL":
              this.progress.anal = true;
              this.LoadYn = false;
              break;
          }
        }
      }
    },
    unsubRaweData() {
      console.log("unsubscribe..");
      this.getWebSocket.send(
        JSON.stringify({
          target: "offRabbitMQData",
          topic: this.curTopicId,
        })
      );
    },
    // Initialize Rawe Chart
    initRaweChart() {
      this.raweChart.chart1 = [
        {
          x: null,
          y: null,
          name: null,
          type: "scatter",
          mode: "lines",
          line: { width: 1 },
        },
      ];
      this.raweChart.chart2 = [];
      this.raweChart.chart3 = [
        {
          x: [],
          y: [],
          mode: "markers",
          type: "scatter",
          marker: {
            size: 10,
            color: [],
          },
        },
      ];
      this.raweChart.chart4 = [
        {
          x: [],
          y: [],
          mode: "markers",
          type: "scatter",
          marker: {
            symbol: [],
            size: 15,
            color: [],
          },
        },
      ];
      this.raweChart.progress.totval = 0;
      this.raweChart.progress.curval = 0;
    },
    initFileChart() {
      for (let i = 1; i <= 6; i++) {
        if (i === 1) {
          this.fileChart["chart" + i] = {
            clearyn: false,
            data: [
              {
                x: [0, 0, null, 0, 0],
                y: [0, 0, null, 0, 0],
                type: "scatter",
                mode: "lines",
                line: {
                  color: "white",
                  width: 1,
                },
              },
            ],
            ymax: 0,
            ymin: 0,
          };
        } else if (i >= 2 && i <= 4) {
          this.fileChart["chart" + i] = {
            clearyn: true,
            data: [],
          };
        } else {
          if (this.search.accumulate === "N") {
            this.fileChart["chart" + i] = {
              clearyn: false,
              data: [],
            };
          }
        }
      }
      this.progress = {
        rawfiledown: false,
        rawfiledownfin: false,
        bin2csv: false,
        bin2csvfin: false,
        anal: false,
        analfin: false,
      };
    },
    // Make Chart Annotations
    setChartAnnotation(axis, param) {
      return {
        xref: "paper",
        yref: "paper",
        x: utils.chkNum(
          param.x,
          axis === "x" ? 0.5 : axis === "y" ? -0.14 : 1.05
        ),
        y: utils.chkNum(param.y, axis === "x" ? -0.15 : 0.5),
        text: param.text,
        textangle: axis === "x" ? 0 : axis === "y" ? -90 : 90,
        font: {
          family: "Open Sans",
          size: 17,
          color: "#e2e2e2",
          weight: "normal",
        },
        showarrow: false,
      };
    },
    startCheckDataMonitoring() {
      if (this.checkData.timer === null) {
        this.checkData.timer = setInterval(() => {
          if (
            moment
              .duration(moment().diff(this.dataLastUpdateTime))
              .asSeconds() > 5
          ) {
            this.stopCheckDataMonitoring();
          }
        }, 1000);
      }
    },
    stopCheckDataMonitoring() {
      if (this.checkData.timer !== null) {
        this.raweChart.progress.loadyn = false;
        clearInterval(this.checkData.timer);
        this.checkData.timer = null;
        this.unsubRaweData();
      }
    },
    excelDownload(evt) {
      var reqBody = {
        csvFilePath: this.csvFilePath,
      };

      this.$http
        .post("/sensor/csvFileDownload", reqBody, {
          responseType: "arraybuffer",
        })
        .then((res) => {
          let fileName = reqBody.csvFilePath.substring(
            reqBody.csvFilePath.lastIndexOf("/") + 1,
            reqBody.csvFilePath.lastIndexOf(".")
          );
          utils.getExcelFile(res, fileName, "csv");
        })
        .catch((err) => {
          this.setAlertTitle();
          this.$bvModal
            .msgBoxOk(err, this.getAlertOptions)
            .then((value) => {})
            .catch((err) => {
              console.error(err);
            });
        });
    },
    selectfile() {
      this.search.dataType = "file";
    },
    /* ,
    openSetting () {
      this.$bvModal.show('sensorDataChartSettingModal')
    },
    chartDataDownload (evt) {
      console.log(this.raweChart)
      let contents = []
      for (let key in this.raweChart) {
        if (key !== 'progress') {
          if (key !== 'chart2') {
            contents.push({
              sheetName: key,
              header: ['x', 'y'],
              content: {
                x: this.raweChart[key][0].x,
                y: this.raweChart[key][0].y
              }
            })
          } else {
            for (let i = 0; i < this.raweChart[key].length; i++) {
              if (i === 0) {
                contents.push({
                  sheetName: key,
                  header: ['x', 'y1'],
                  content: {
                    x: this.raweChart[key][i].x,
                    y1: this.raweChart[key][i].y
                  }
                })
              } else {
                let head = 'y' + (i + 1)
                contents[contents.length - 1].header.push(head)
                contents[contents.length - 1].content[head] = this.raweChart[key][i].y
              }
            }
          }
        }
      }
      let ssIdx = 0
      for (ssIdx = 0; ssIdx < this.search.sensorAliasOptions.length; ssIdx++) {
        if (this.search.sensorAliasOptions[ssIdx].value === this.search.sensorAlias) break
      }
      var reqBody = {
        fileName: 'RAWE 데이터', // this.search.sensorAliasOptions[ssIdx].text + ' RAWE 데이터',
        data: contents
      }
      console.log(reqBody)
      this.$http.post('/sensor/excelDownload', reqBody, {timeout: 60 * 1000}, {responseType: 'arraybuffer'}).then(res => {
        utils.getExcelFile(res, evt.path[1], reqBody.fileName)
      }).catch(err => {
        console.error(err)
      })
    } */
    // sampling rate
    getSamplingRate(sensoridx) {
      if (sensoridx === null) {
        this.samplingRate = null;
        return;
      }
      this.$http
        .post("/sensor/getSensorConfig", { sensoridx: sensoridx })
        .then((res) => {
          if (res.data.resultyn !== "Y") {
            this.samplingRate = null;
          }
          let data = res.data.data;
          let samplerate = data.samplerate;
          if (samplerate === null) {
            this.samplingRate = null;
          }
          this.samplingRate = samplerate + "Hz";
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },
};
</script>

<style lang="scss">
#sensorDataHistory {
  padding: 15px;
  & .chartOptions {
    & .row {
      height: 50px;
      & .col {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 10px 0;
        & label {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          color: #b4b7bd;
          width: 100px;
          height: 100%;
          margin-bottom: 0;
        }
        & input,
        & select {
          width: 200px;
        }
      }
    }
  }
  & .rawe-progress {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0px;
    left: 0px;
    background-color: rgba(6, 6, 6, 0.3);
    & > div.progress {
      position: relative;
      top: calc(50% - 15px);
      width: 400px;
      height: 30px;
      left: calc(50% - 200px);
    }
  }
  & .searchBox {
    justify-content: space-between;
    border-radius: 5px;
    & > div:first-child {
      & > label {
        display: flex;
        align-items: center;
        height: 100%;
        font-size: 16px;
      }
    }
    & .prog {
      display: flex;
      align-items: center;
      height: 100%;
      color: #fff;
      font-size: 16px;
      margin-right: 20px;
      &:last-child {
        margin-right: 0;
      }
    }
    & .custom-checkbox {
      & > input[type="checkbox"] {
        width: 140px;
      }
      & > label {
        display: flex;
        align-items: center;
        justify-content: center;
        &.custom-control-label {
          &::before,
          &::after {
            top: 7px;
            left: -20px;
          }
        }
      }
    }
  }
  & .chartarea {
    & .card {
      & .card-header {
        padding: 6px 15px 8px;
        border-bottom: 1px solid #404656;
        & h6 {
          font-size: 15px;
          line-height: unset;
          justify-content: center;
        }
      }
      & .card-body {
        & .graph {
          height: 100%;
        }
      }
    }
  }
  .select-container {
    .vs__dropdown-toggle {
      width: 200px;
      height: 35px;
      margin-right: 0px;
    }
    .vs__search::placeholder {
      color: #b4b7bd !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sensor/SensorDataHistory.vue